import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../shared/dataservice.service';
import { UiTblSubSOBrkPSLevel } from '../../shared/ui-classes';
import { ChangeNoteMonthFilterDialog, ChangeNoteMonthFilterPayload } from '../../dialogs/change-note-month-filter-dialog/change-note-month-filter-dialog';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {

  constructor(private _dataService: DataService, private dialog: MatDialog) {
    this._dataService.currPageName = 'Downloads';
  }
  _breakerPSUIObjList: Array<UiTblSubSOBrkPSLevel>;
  isLoading:boolean = false;
  ngOnInit() {

  }
 
  downloadExcel(isArchive:boolean) {
    if(isArchive == false){
      this._dataService.downloadFile('mast');
    }
    else{
      this._dataService.downloadFile('mast2');
    }
    
  }  
  downloadExcelreport(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('report');
  }
  downloadExcelmark(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('mrktg');
  }
  downloadExcelbrkrp(isArchive:boolean) {
    if(isArchive == false){
      this._dataService.downloadFile('brkrp');
    }
    else{
      this._dataService.downloadFile('brkrp2');
    }
    
  }
  downloadExceldspch(isArchive:boolean) {
    if(isArchive == false){
    this._dataService.downloadFile('dspch');
    }
    else{
      this._dataService.downloadFile('dspch2')
    }
  }
  downloadManfExcel(isArchive:boolean) {
    if(isArchive == false){
      this._dataService.downloadFile('manf');
    }
    else{
      this._dataService.downloadFile('manf2')
    }
		
	}
  downloadSerialExcelDspch(isArchive:boolean) {
    if(isArchive == false){
      this._dataService.downloadFile('serial');
    }
    else{
      this._dataService.downloadFile('serial2')
    }
		
	}

  downloadChangeNoteExcelDspch(isArchive:boolean) {
    const reportType = (isArchive == false) ? 'change' : 'change2';
    const reportName = (isArchive == false) ? 'Change Note Details' : 'Dispatched Change Note Details';

    let dialogRef = this.dialog.open(ChangeNoteMonthFilterDialog, {
      width: '50%',
      data: { reportName: reportName }
    });

    dialogRef.afterClosed().subscribe((filterPayload: ChangeNoteMonthFilterPayload) => {
      if (filterPayload) {
        this._dataService.downloadFile(reportType, filterPayload);
      }
    });
	}
  downloadQmsEleExcel() {
    this._dataService.downloadFile('qms_ele');
  }
  downloadDatasheetExportExcel() {
    this._dataService.downloadFile('datasheet_export');
  }
}
